// extracted by mini-css-extract-plugin
export var active = "_1g-9";
export var backButton = "_1g-8";
export var clone = "_1g-e";
export var collapseBar = "_1g-k";
export var collapseMode = "_1g-m";
export var collapsed = "_1g-o";
export var dimmed = "_1g-i";
export var dragHandle = "_1g-c";
export var dropdownIcon = "_1g-g";
export var expanding = "_1g-n";
export var hidden = "_1g-x";
export var iconContainer = "_1g-q";
export var iconSwapper = "_1g-w";
export var navItem = "_1g-6";
export var navItemIcon = "_1g-f";
export var navProfile = "_1g-7";
export var notificationCountBadge = "_1g-j";
export var notificationDot = "_1g-r";
export var optionsContainer = "_1g-h";
export var primaryNav = "_1g-0";
export var primaryNavDivider = "_1g-v";
export var primaryNavResizeHandle = "_1g-2";
export var primaryNavResizing = "_1g-1";
export var primaryNavTabSection = "_1g-u";
export var primaryTab = "_1g-p";
export var primaryTabIconBox = "_1g-s";
export var secondaryNav = "_1g-3";
export var selected = "_1g-t";
export var settingsNav = "_1g-4";
export var settingsNavItems = "_1g-5";
export var show = "_1g-d";
export var sideNav = "_1g-l";
export var teamItem = "_1g-a";
export var userProfileItem = "_1g-b";